import { costService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, costs: [], cost: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        costService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        costService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/costs');
                    dispatch('alert/success', "Cost Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/costs');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        costService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/costs');
                    dispatch('alert/success', "Cost Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/costs');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        costService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      costService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/costs');
                  dispatch('alert/success', "Cost Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/costs');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_cost_by_account({ dispatch, commit }, data) {
        commit('request');

        costService.get_cost_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  costs: state => {
    return state.costs
  },
  cost: state => {
    return state.cost
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.cost = {};
        state.costs = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.cost = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.costs = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const costs = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
